module.exports = __webpack_public_path__ + "img/Search-Profiles.71e89a2c.jpg";